export const MAX_PAGE_HEIGHT = '100vh';
export const MAX_PAGE_WIDTH = '100vw';
export const MENU_WIDTH = '184px';
export const HEADER_HEIGHT = '64px';
export const FOOTER_HEIGHT = '64px';
export const PAGE_CONTAINER_HEADER_HEIGHT = '60px';
